<template>
  <b-container>
    <b-row>
      <b-col>
        <SkeletonTableLoader :columns="headers" :loading="skeletonloading" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <Tableview
          :value="list"
          :paginator="true"
          class="p-datatable-gridlines commonstatusclass"
          :rows="10"
          :rowHover="true"
          filterDisplay="menu"
          responsiveLayout="scroll"
          :columns="headers"
          :globalFilterFields="globalFilterFields"
          :filters="filters"
          :exceldownload="true"
          :filterbtn="true"
          :statusFilterBtn="true"
        >
          <template v-slot:status="{ data }">
            <RedStatus name="Close" v-if="data.CurrentStatus == 0" />
            <GreenStatus name="Active" v-if="data.CurrentStatus == 2" />
          </template>
          <template v-slot:action="{ data }">
            <span>
              <Button
                icon="pi pi-ellipsis-v"
                class="p-button-rounded editicon p-button-text"
                @click="toggle($event, data)"
              />
            </span>
          </template>
        </Tableview>
      </b-col>
    </b-row>
  </b-container>
  <Menu ref="menu" id="overlay_menu" :model="actionlist" :popup="true" />
  <EditConfirmation
    :Editmodel="Editmodel"
    @yes="IsDelete(tableData)"
    @no="Editmodel = false"
    content="Are you sure you want to close Escalation"
    HeaderContent=""
  />
  <CancelSuccessfully
    :visible="closeEscalationStatus"
    content="Escalation Closed Successfully"
    @ok="closetrigger()"
  />
</template>
<script lang="ts">
import { defineComponent, onMounted, ref, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import AssetMaintenanceService from "../../../../../../../modules/Inventory/Service/AssetManagement/AssetMaintenanceService";
import SkeletonTableLoader from "../../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../../components/FormComponents/Table.vue";
import EscalationService from "../../../../../../../modules/Inventory/Service/AssetManagement/EscalationService";
import CancelSuccessfully from "../../../../../../../components/FormComponents/CancelSuccessfully.vue";
import EditConfirmation from "../../../../../../../components/FormComponents/EditConfirmation.vue";

export default defineComponent({
  components: {
    SkeletonTableLoader,
    Tableview,
    CancelSuccessfully,
    EditConfirmation,
  },

  setup() {
    const { t } = useI18n();
    const skeletonloading = ref(false);
    const closeEscalationStatus = ref(false);
    const Editmodel = ref(false);
    const router = useRouter();
    const routes = useRoute();
    const menu = ref();
    const list = ref([]);
    const tableData = ref();
    let SessionRoleData = localStorage.getItem("RolesData");
    let SessionUserData = localStorage.getItem("userdata");
    let RolesData;
    let usersData;
    if (SessionRoleData !== null) {
      RolesData = JSON.parse(SessionRoleData);
    }
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    let isAdmin = usersData?.Admin || 0;
    onMounted(() => {
      IsShow();
    });
    const headers = ref([
      {
        header: t("assetManagement.maintenancedetails.escalation.sno"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t("assetManagement.maintenancedetails.escalation.asset"),
        field: "AssetName",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
        bodyclass: "boldclass text_overflow2",
      },
      {
        header: t(
          "assetManagement.maintenancedetails.escalation.escalationdate"
        ),
        field: "EscalationDate",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.maintenancedetails.escalation.assignedto"),
        field: "AssignedToName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.maintenancedetails.escalation.reason"),
        field: "ReasonName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.maintenancedetails.escalation.actiontaken"),
        field: "ActionTaken",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.maintenancedetails.escalation.status"),
        field: "Status",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        slot: "status",
        fieldDisplay: "false",
      },

      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        hide: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ]);

    const globalFilterFields = ref(headers.value.map((col) => col.field));

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      AssetName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      Status: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      EscalationDate: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      LastMaintenanceDate: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      ActionTaken: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
      Reason: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },

      Status: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: list,
      },
    };
    const toggle = (event, data) => {
      tableData.value = data;
      menu.value.toggle(event);
    };

    const actionlist = ref([
      {
        items: [
          {
            label: "Close Escalation",
            icon: "pi pi-times",
            visible: true,
            command: async () => {
              Editmodel.value = true;
            },
          },
        ],
      },
    ]);

    async function IsShow() {
      try {
        let roleId;
        if (isAdmin !== 1) {
          roleId = RolesData.RoleId;
        } else {
          roleId = 0;
        }
        let count = 0;
        skeletonloading.value = true;
        const dataresponse = await EscalationService.getdata();
        list.value = dataresponse["result"].map((item) => {
          count = count + 1;
          item.RowNumber = count;
          return item;
        });
        skeletonloading.value = false;
      } catch (error) {
        console.log(error);
      }
    }
    async function IsDelete(data) {
      try {
        Editmodel.value = false;
        let response: any = "";
        response = await EscalationService.updateStatusbyId(data.Id);

        let message = response["ErrorInfo"].ErrorCode;

        if (message == null) {
          closeEscalationStatus.value = true;
          IsShow();
        }
      } catch (error) {
        alert(error);
      }
    }
    function closetrigger() {
      closeEscalationStatus.value = false;
    }
    return {
      skeletonloading,
      router,
      routes,
      menu,
      list,
      IsShow,
      toggle,
      t,
      headers,
      globalFilterFields,
      actionlist,
      filters,
      IsDelete,
      closeEscalationStatus,
      closetrigger,
      Editmodel,
      tableData,
    };
  },
});
</script>
